import {
	form602SubmissionDeleteQuery,
	useAxiosInstance,
	usePoMutation,
} from '@gov-nx/api';

interface Form602SubmissionDeleteQueryProps {
	formularPodaniId: string;
	onSuccess?: () => void;
}

export const useForm602SubmissionDeleteQuery = (
	props: Form602SubmissionDeleteQueryProps
) => {
	const { axiosInstance } = useAxiosInstance();
	const mutation = usePoMutation({
		mutationFn: form602SubmissionDeleteQuery,
		onSuccess: () => {
			props?.onSuccess && props.onSuccess();
		},
	});

	return {
		...mutation,
		deleteFormSubmission: () =>
			mutation.mutate({
				formularPodaniId: props.formularPodaniId,
				axiosInstance,
			}),
	};
};
